import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import isNotNullOrEmpty from 'utilities/is/isNotNullOrEmpty';
import Divider from '@material-ui/core/Divider';
import { H4, Body1 } from 'components/Typography';
import styles from './styles';
import m from 'messages';
import { DateTime } from 'luxon';
import { toShortDateTimeString } from 'utilities/formatters/dateTimeFormatter'

function Breathalyser(props) {

    const { card, classes } = props;
    const hasBreathalyserResults = isNotNullOrEmpty(card.breathalyserTestsForSite) && card.hasBreathalyserTestForSite;
    const result = hasBreathalyserResults ? card.breathalyserTestsForSite[card.breathalyserTestsForSite.length-1] : [];
    return (
        <div className={classes.fullWidth}>
            {hasBreathalyserResults &&
                <div className={classes.container}>
                    <H4 paragraph>
                        {m.cards.breathalyserHeader}
                    </H4>
                    <div className={classes.body}>
                        <Body1 paragraph>
                            Last site breathalyser test: {toShortDateTimeString(DateTime.fromFormat(result.testDate, 'dd/MM/yyyy HH:mm', { zone: 'utc' }).toLocal())}
                        </Body1>
                        <Divider />
                    </div>
                </div>
            }
        </div>
    );
}

Breathalyser.propTypes = {
    card: PropTypes.object.isRequired
};

export default withStyles(styles)(Breathalyser);